import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Button, useActiveModifiers, useDayRender } from "react-day-picker";
import { useDateRangePickerContext } from "../date-range-picker/DateRangePickerContext";
import { useTabWithinRange } from "./useTabWithinRange";
/**
 * Customizes this file: https://github.com/gpbl/react-day-picker/blob/master/packages/react-day-picker/src/components/Day/Day.tsx
 */
export function Day({ date, displayMonth }) {
    const buttonRef = useRef(null);
    const dayRender = useDayRender(date, displayMonth, buttonRef);
    const modifiers = useActiveModifiers(date, displayMonth);
    const { selectingDescriptionId } = useDateRangePickerContext();
    const { tabIndex, onKeyDown, ...buttonProps } = dayRender.buttonProps;
    const { tabWithinRange } = useTabWithinRange({ date, displayMonth });
    if (dayRender.isHidden) {
        return _jsx(_Fragment, {});
    }
    if (!dayRender.isButton) {
        // Always render a button
        // https://github.medallia.com/Alchemy/alchemy/pull/4664#discussion_r617619)
        return _jsx(Button, { "data-testid": "DateCalendarDay", ...dayRender.divProps, disabled: true });
    }
    return (_jsx(Button, { ref: buttonRef, "data-testid": "DateCalendarDay", ...buttonProps, onKeyDown: (e) => {
            tabWithinRange(e);
            onKeyDown?.(e);
        }, tabIndex: modifiers.range_end || modifiers.range_start ? 0 : tabIndex, "aria-describedby": selectingDescriptionId || undefined }));
}
